import { ReactNode } from "react";
import {
  Redirect,
  Route,
  RouteProps,
} from "react-router-dom";

import { useAppSelector } from "#redux/store";

interface PrivateRouteProps extends RouteProps {
  children: ReactNode;
}

function PrivateRoute({ children, ...rest }: PrivateRouteProps) {

  const auth = useAppSelector((state) => state.auth);

  const renderFunc = () => {
    if (!auth.ready) {
      // FIXME: Add loader
      return null;
    }
    if (auth.is_logged) {
      return children;
    }

    return (
      <Redirect
        to={{
          pathname: "/",
        }}
      />
    );
  };

  return (
    <Route
      {...rest}
      render={renderFunc}
    />
  );
}

export default PrivateRoute;
